import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4f97b6de"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=4f97b6de&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports